/*TOP FV スライダー*/
jQuery(function (jQuery) {
  // 画像ズームアニメーション
  // 最初のスライドに"add-animation"のclassを付ける(data-slick-index="0"が最初のスライドを指す)
  jQuery(".fv_slider .slideshow").on("init", function () {
    jQuery('.slick-slide[data-slick-index="0"]').addClass("add-animation");
  });

  jQuery(".fv_slider .slideshow").slick({
    autoplaySpeed: 4000,
    autoplay: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    fade: true,
    speed: 2000,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {},
      },
    ],
  });

  jQuery(".fv_slider .slideshow").on({
    // スライドが移動する前に発生するイベント
    beforeChange: function (event, slick, currentSlide, nextSlide) {
      // 表示されているスライドに"add-animation"のclassをつける
      jQuery(".slick-slide", this).eq(nextSlide).addClass("add-animation");
      // あとで"add-animation"のclassを消すための"remove-animation"classを付ける
      jQuery(".slick-slide", this).eq(currentSlide).addClass("remove-animation");
    },
    // スライドが移動した後に発生するイベント
    afterChange: function () {
      // 表示していないスライドはアニメーションのclassを外す
      jQuery(".remove-animation", this).removeClass("remove-animation add-animation");
    },
  });
});

/*アコーディオン*/
$(function () {
  //クリックで動く
  $(".accordion > dt").click(function () {
    $(this).toggleClass("active");
    $(this).next("dd").slideToggle();
  });
});

/*タブ切り替え*/
$(function () {
  $(".tab_btn_list .tab_btn").click(function () {
    var index = $(this).parent(".tab_btn_list").children(".tab_btn").index(this);
    $(this).parent(".tab_btn_list").children(".tab_btn").removeClass("active");
    $(this).parent(".tab_btn_list").next(".tab_area").children(".tab_box").removeClass("active");
    $(this).addClass("active");
    $(this).parent(".tab_btn_list").next(".tab_area").children(".tab_box").eq(index).addClass("active");
  });
});

function checkBreakPoint() {
  w = $(window).width();
  if (w <= 767) {
    // スマホ向け（767px以下のとき）
  } else {
    // PC向け
  }
}
// ウインドウがリサイズする度にチェック
$(window).resize(function () {
  checkBreakPoint();
});
// 初回チェック
jQuery(function () {
  checkBreakPoint();
});
